import type { AdvisoryUiStateMap } from './advisoryUi.model';

export function isBasketOptimizerAccordionOpened(state: AdvisoryUiStateMap, tabId: string): boolean {
  return (state && state[tabId]?.isBasketOptimizerAccordionOpened) ?? false;
}
